// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6e20d86f","977":"4c028df1"}[chunkId] + ".chunk.js";
};